<template>
  <div class="preview_wrap" v-loading="loading">
    <div class="preview_midle">
      <div class="header">
        <p>{{name}}（{{total}}）</p>
      </div>
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="(item,index) in questionTabNames" :key="index" :label="item.sectionAlias ||  item.sectionName" :name="'page'+index"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="section" :style='{height:styleHeight}' @scroll="handleScroll" ref="content">
        <div class="test">
          <ul>
            <li :id="['page'+index]" v-for="(item,index) in questionContent" :key="index" class="test-item">
              <div class="title">{{chnNumCharStr(index)}}  、{{ item.sectionAlias ||  item.sectionName}}<span>（{{item.sectionPrompt}}）</span></div>
              <ul>
                <li class="test_small" v-for="(v,i) in item.questions" :key="i">
                  <!--非组合题-->
                  <div v-if="v.internalTypeId !== 6">
                    <span class="text_index1" v-if="v.internalTypeId === 9">{{v.questionNum}}.</span>
                    <div class="text_box">
                      <span class="text_index" v-if="v.internalTypeId !== 9">{{v.questionNum}}.</span>
                      <div class="test_small_title1" v-if="v.internalTypeId === 9"><p class="text editorShowArea ql-editor" v-html="v.questionContent"></p></div>
                      <div class="test_small_title editorShowArea ql-editor" v-html="v.questionContent" v-if="v.internalTypeId !== 9"></div>
                    </div>
                    <!--单选题-->
                    <ul class="answer editorShowArea" v-if="v.internalTypeId === 1">
                      <el-radio-group v-model="v.questionAnswer">
                        <li v-for="(k,j) in v.items" :key="j"><el-radio :label="k.itemKey" :disabled="v.questionAnswer == k.itemKey? false:true"><span>{{k.itemKey}}：</span><div class="radio_item editorShowArea ql-editor" v-html="k.itemValue"></div></el-radio></li>
                      </el-radio-group>
                    </ul>
                    <!--多选题-->
                    <ul class="answer" v-if="v.internalTypeId === 2">
                      <el-checkbox-group v-model="v.questionAnswer.split(',')">
                        <li v-for="(k,j) in v.items" :key="j"><el-checkbox :disabled="v.questionAnswer.includes(k.itemKey)? false:true" :label="k.itemKey"><span>{{k.itemKey}}：</span><p v-html="k.itemValue"></p></el-checkbox></li>
                      </el-checkbox-group>
                    </ul>
                    <!--判断题-->
                    <ul class="answer" v-if="v.internalTypeId === 3">
                      <li><el-radio v-model="v.questionAnswer" label="正确" :disabled="v.questionAnswer=='错误'?true:false">{{ answerExchange(v.englishOption, '正确') }}</el-radio></li>
                      <li><el-radio v-model="v.questionAnswer" label="错误" :disabled="v.questionAnswer=='正确'?true:false">{{ answerExchange(v.englishOption, '错误') }}</el-radio></li>
                    </ul>
                    <p v-if="v.internalTypeId === 1 || v.internalTypeId === 2 || v.internalTypeId === 3">正确答案：<span>{{answerExchange(v.englishOption, v.questionAnswer)}}</span></p>
                    <div v-if="v.internalTypeId === 4">正确答案
                      <div style="margin: 10px">
                        <div v-for="(item,key,index) in JSON.parse(v.questionAnswer)" :key="key" :index="index">
                          <div v-for="(a,b) in item" :key="b">
                            <div v-if="item.length >1">
                              <div style="margin: 10px;color: #5397F7" v-if="b<1">
                                {{index-0+1 + "、答案：" + a}}
                              </div>
                              <div style="margin: 10px 0 0 35px;color: #5397F7" v-else>
                                {{"备选答案" + b + ":" + a}}
                              </div>
                            </div>
                            <div v-else style="margin: 10px;color: #5397F7">
                              {{index-0+1 + "、答案：" + a}}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="analysis" v-if="v.flag && v.internalTypeId !== 9" @click="openAnalysis(v)">打开解析<img :src="imgSrcDown"/></div>
                    <div class="analysis" v-if="!v.flag && v.internalTypeId !== 9" @click="openAnalysis(v)">收起解析<img :src="imgSrcUp"/></div>
                    <span v-if="!v.flag && v.internalTypeId !== 9" class="analysis_cont editorShowArea ql-editor" v-html="v.questionAnalysis?v.questionAnalysis:'暂无解析'"></span>
                    <span class="answerShow" v-if="v.flag && v.internalTypeId === 9" @click="openAnalysis(v)">打开答案<img :src="imgSrcDown"/></span>
                    <span class="answerHide" v-if="!v.flag && v.internalTypeId === 9" @click="openAnalysis(v)">收起答案<img :src="imgSrcUp"/></span>
                    <div class="commentCont" v-if="!v.flag && v.internalTypeId == 9">
                      <div class="comment1"></div>
                      <div class="comment2">
                        <my-component isShow :optObject="optObject" :refresh="refresh" :myId="v.questionId" :type="type" :preview="true" :companyCode="companyCode"></my-component>
                      </div>
                      <div class="comment3"></div>
                    </div>
                  </div>
                  <!--组合题-->
                  <div class="line" v-if="v.internalTypeId === 6 && item.questions.length > 1"></div>
                  <div class="combination" v-if="v.internalTypeId === 6">
                    <div class="test_small_title1" v-if="v.internalTypeId === 9"><p class="text editorShowArea ql-editor" v-html="v.questionContent"></p></div>
                    <p class="question_index" v-if="v.questionNum == v.questionNum + v.childQuestions.length -1">阅读以下内容，回答第{{v.questionNum}}题</p>
                    <p class="question_index" v-else>阅读以下内容，回答第{{v.questionNum}}-{{v.questionNum + v.childQuestions.length -1}}题</p>
                    <div class="test_small_title" v-html="v.questionContent" v-if="v.internalTypeId !== 9"></div>
                    <div class="groupQuestion" v-for="(single,m) in v.childQuestions" :key="m">
                      <div class="question_content">
                        <span>{{ single.questionNum }}.</span>
                        <p class="text editorShowArea ql-editor" v-html="single.questionContent"></p>
                      </div>
                      <!--单选题-->
                      <ul class="answer" v-if="single.internalTypeId === 1">
                        <el-radio-group v-model="single.questionAnswer">
                          <li v-for="(k,j) in single.items" :key="j"><el-radio :label="k.itemKey" :disabled="single.questionAnswer == k.itemKey? false:true"><span>{{k.itemKey}}：</span><div class="radio_item editorShowArea ql-editor" v-html="k.itemValue"></div></el-radio></li>
                        </el-radio-group>
                      </ul>
                      <!--多选题-->
                      <ul class="answer" v-if="single.internalTypeId === 2">
                        <el-checkbox-group v-model="single.questionAnswer.split(',')">
                          <li v-for="(k,j) in single.items" :key="j"><el-checkbox :disabled="single.questionAnswer.includes(k.itemKey)? false:true" :label="k.itemKey"><span>{{k.itemKey}}：</span><p v-html="k.itemValue"></p></el-checkbox></li>
                        </el-checkbox-group>
                      </ul>
                      <!--判断题-->
                      <ul class="answer" v-if="single.internalTypeId === 3">
                        <li><el-radio v-model="single.questionAnswer" label="正确" :disabled="single.questionAnswer=='错误'?true:false">{{ answerExchange(single.englishOption, '正确') }}</el-radio></li>
                        <li><el-radio v-model="single.questionAnswer" label="错误" :disabled="single.questionAnswer=='正确'?true:false">{{ answerExchange(single.englishOption, '错误') }}</el-radio></li>
                      </ul>
                      <p v-if="single.internalTypeId === 1 || single.internalTypeId === 2 || single.internalTypeId === 3">正确答案：<span>{{answerExchange(single.englishOption, single.questionAnswer)}}</span></p>
                      <div v-if="single.internalTypeId === 4">正确答案：<p v-html="single.questionAnswer"></p></div>
                      <div class="analysis" v-if="single.flag && single.internalTypeId !== 9" @click="openAnalysis(single)">打开解析<img :src="imgSrcDown"/></div>
                      <div class="analysis" v-if="!single.flag && single.internalTypeId !== 9" @click="openAnalysis(single)">收起解析<img :src="imgSrcUp"/></div>
                      <span v-if="!single.flag && single.internalTypeId !== 9" class="analysis_cont editorShowArea ql-editor" v-html="single.questionAnalysis?single.questionAnalysis:'暂无解析'"></span>
                      <span class="answerShow" v-if="single.flag && single.internalTypeId === 9" @click="openAnalysis(single)">打开答案<img :src="imgSrcDown"/></span>
                      <span class="answerHide" v-if="!single.flag && single.internalTypeId === 9" @click="openAnalysis(single)">收起答案<img :src="imgSrcUp"/></span>
                      <div class="commentCont" v-if="!single.flag && single.internalTypeId == 9">
                        <div class="comment1"></div>
                        <div class="comment2">
                          <my-component isShow :optObject="optObject" :refresh="refresh" :myId="single.questionId" :type="type" :preview="true" :companyCode="companyCode"></my-component>
                        </div>
                        <div class="comment3"></div>
                      </div>
                    </div>
                  </div>
                  <div class="line" v-if="v.internalTypeId === 6 && item.questions.length > 1"></div>
                  <div style="clear: both"></div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import * as api from "../../../../../api/testApi";
  import myComponent from "../../../../myComponent.vue"
  export default {
    data(){
      return {
        name:'',
        styleHeight:window.innerHeight - 110+"px",
        activeName:'page0',
        imgSrcDown:'../../../../../../static/images/study/icon/down.png',
        imgSrcUp:'../../../../../../static/images/study/icon/up.png',
        questionTabNames:[],
        questionContent:[],
        loading:true,
        chnNumChar:["一","二","三","四","五","六","七","八","九"],
        userType:sessionStorage.getItem('userType'),
        total:'',
        optObject:{},
        refresh:false, //刷新数据
        iframeUrl:'',
        classId: this.$route.query.classId,
        type:'',
        productFlag: sessionStorage.getItem('productFlag'),
        companyCode:'',
        template: {},
				subjectId: '',
				paperCode: '',
        virtualList:[],
        virtualKeys:[],
      }
    },
    components:{
      myComponent,
    },
    created(){
      this.optObject = this.$route.query;
      this.getTehDate();
      if(this.productFlag == 3){
        this.type = 3;
      }else{
        this.type = 2;
      }
    },
    methods:{
      handleClick(tab, event) {
        var PageId = document.querySelector('#page' + tab.index);
        PageId.scrollIntoView();
      },
      // 打开解析(收起解析)
      openAnalysis(param){
        this.$set(param,'flag',!param.flag);
        this.getparams(param.questionId);
      },
      //获取测验预览数据
      getTehDate(){
          let { token } = this.$route.query
          if(token){
              localStorage.setItem('Authorization', this.$route.query.token)
          }
        let paperId = this.$route.query.paperId;
        let index = 1;
        let request
        if(this.$route.query.classId){
          let param = {
            id:paperId,
            courseId:this.$route.query.id,
            classId:this.$route.query.classId
          }
          request = api.getTeacherPreview(param)
        }else{
          request = api.testPaper(paperId)
        }
        request.then(res=>{
          if(res.code == 0){
            this.name = res.data.paperName;
            this.total = res.data.totalScore+'分';
						this.subjectId = res.data.subjectId;
						this.paperCode = res.data.paperCode;
            this.questionTabNames = res.data.testPaperPartsList[0].testPaperSectionsList;
            let testPaperDates = res.data.testPaperPartsList[0].testPaperSectionsList;
            testPaperDates.forEach(val=>{
              let obj = {};
              obj.sectionName = val.sectionName;
              obj.sectionPrompt = val.sectionPrompt;
              obj.questions = [];
              val.testPaperQuestionsList.forEach(item=>{
                let question = {};
                question.internalTypeId = item.questionDto.internalTypeId;
                question.questionContent = item.questionDto.questionContent;
                question.items = item.questionDto.items;
                if (item.questionDto.questionAnswer){
                  question.questionAnswer = item.questionDto.questionAnswer.replace(/(^\s*)|(\s*$)/g, "");
                }
                question.questionAnalysis = item.questionDto.questionAnalysis;
								question.questionCode = item.questionDto.questionCode;
                question.flag = true;
                question.score = item.questionDto.score;
                question.questionNum = index++;
                question.questionId = item.questionDto.id;
                question.childQuestions = [];
                question.englishOption = item.questionDto.englishOption;
                if(question.internalTypeId == 6){
                  index--
                  item.questionDto.childQuestions.forEach(m=>{
                    let childQuestionsObj = {};
                    childQuestionsObj.internalTypeId = m.internalTypeId;
                    childQuestionsObj.questionContent = m.questionContent;
                    childQuestionsObj.items = m.items;
                    childQuestionsObj.questionAnswer = m.questionAnswer.replace(/(^\s*)|(\s*$)/g, "");
                    childQuestionsObj.questionAnalysis = m.questionAnalysis;
                    childQuestionsObj.questionId = m.id;
										childQuestionsObj.questionCode = m.questionCode;
                    childQuestionsObj.questionNum = index++;
                    childQuestionsObj.flag = true;
                    childQuestionsObj.englishOption = m.englishOption;
                    question.childQuestions.push(childQuestionsObj);
                  });
                }
                obj.questions.push(question);
              });
              this.questionContent.push(obj);
            });
            for (let i = 0; i < this.questionContent.length; i++) {
              for (let j = 0; j < this.questionContent[i].questions.length; j++) {
                if (this.questionContent[i].questions[j].internalTypeId == 4){
                  this.virtualList.push(JSON.parse(this.questionContent[i].questions[j].questionAnswer))
                  // this.virtualList.push(this.questionContent[i].questions[j])
                  // 2222222222222222222222222222222222222222222222222222222222222222222222222222222
                }
              }
            }
            console.log(this.virtualList,"this.virtualList")
            for (let i = 0; i < this.virtualList.length; i++) {
              this.virtualKeys.push({key:Object.keys(this.virtualList[i])})
            }
            console.log(this.virtualKeys,"this.virtualKeys")
            this.loading = false;
          }else {
            this.loading = false;
            this.$messageError(res.msg)
          }
        }).catch(error=>{
          this.loading = false;
        })
      },
      //阿拉伯数字转中文
      chnNumCharStr(index){
        return this.chnNumChar[index];
      },

      handleScroll(){
        let scrollTop = this.$refs.content.scrollTop
        let topicLi = document.querySelectorAll('.test-item');
        topicLi.forEach((item, index) => {
          if (scrollTop >= (item.offsetTop-120)) {
            this.activeName = 'page'+index
          }
        });
      },
      /**
       *
       *根据资源ID 获取动态参数列表
       */
      getparams(questionId){
        let list = [];
        return new Promise((resolve) => {
          api.getParams(questionId).then(rs => {
            // console.log(rs);
            if (rs.code === "0") {
              if (rs.data.length > 0) {
                rs.data.map((item)=>{
                  let obj={
                    key:item.param,
                    value: item.value
                  }
                  list.push(obj);
                  if(item.param === "templateCode"){
                    this.companyCode = item.value;
                  }
                })
                resolve(list);
              }
              resolve(list);
            }else{
              this.$messageError(rs.msg);
            }
          })
            .catch(function (error) {
              this.$messageError("后台接口错误！");
            });
        })
      },
      // 判断题 中英文选项
      answerExchange(english, answer) {
        return english ? (answer == "正确" ? "T" : "F") : answer;
      }
    }
  }
</script>

<style scoped lang="scss">
  .preview_wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    background: #F4F4F4;
    .preview_midle {
      background: #F4F4F4;
      height: 100%;
      .header {
        padding: 0 183px;
        p {
          height: 56px;
          background: #1D70E2;
          line-height: 56px;
          text-align: center;
          font-size: 18px;
          color: #fff;
          font-family:Source Han Sans CN;
        }
      }
      .tabs {
        padding: 0 183px;
        .el-tabs {
          background: #FAFCFD;
          padding: 0 108px;
        }
        /deep/ .el-tabs__item {
          font-size: 16px;
          font-family:Microsoft YaHei;
          font-weight:normal;
          color: #999999;
        }
        /deep/ .el-tabs__item.is-active {
          color: #333333;
          font-weight: 600;
        }
        /deep/ .el-tabs__active-bar {
          height: 1px;
          background-color: #333333;
        }
      }
      .section {
        overflow: auto;
        padding: 0 183px;
        padding-left: 183px;
        padding-right: 177px;
        .test {
          padding: 0 108px;
          background: #FAFCFD;
          padding-top: 15px;
          padding-bottom: 20px;
          .test-item {
            margin-bottom: 40px;
            .title {
              color: #333333;
              font-size: 16px;
              font-weight: 600;
              margin-bottom: 16px;
              span {
                font-size: 12px;
                font-weight: 400;
              }
            }
            .test_small {
              justify-content: space-around;
              margin-bottom: 40px;
              .text_box{
                display: flex;
                justify-content: left;
              }
              /deep/ p.ql-align-justify{
                margin-top: -5px;
              }
              .text_index {
                font-size: 14px;
                color: #333333;
                font-weight: 600;
                margin-right: 10px;
              }
              .text_index1 {
                float: left;
                font-size: 14px;
                color: #333333;
                font-weight: 600;
                line-height: 26px;
                margin-right: 10px;
              }
              .test_small_title {
                font-size: 14px;
                margin-bottom: 16px;
                display: inline-block;
                /deep/ p {
                  display: inline-block;
                  img {
                    width: 100%;
                  }
                  span {
                    line-height: 24px;
                    img {
                      width: 100%;
                    }
                  }
                }
              }
              .test_small_title1 {
                font-size: 14px;
                margin-bottom: 16px;
                p.text {
                  width: 100%;
                  line-height: 26px;
                  /deep/ p {
                    img {
                      display: block;
                      max-width: 100%;
                    }
                  }
                  span {
                    line-height: 24px;
                  }

                }
              }
              .answer_radio {
                display: inline-block;
                span {
                  display: inline-block;
                  padding: 0 30px;
                  color: #5397F7;
                  font-size: 14px;
                }
              }
              .panduan {
                line-height: 24px;
              }
              .answer {
                margin-left: 34px;
                margin-top: 10px;
                .el-radio-group {
                  width: 100%;
                }
                li {
                  margin-bottom: 16px;
                  width: 100%;
                  /deep/ .el-radio__input.is-disabled {
                    .el-radio__inner {
                      cursor: pointer;
                    }
                  }
                  /deep/ .el-radio__input.is-disabled+span.el-radio__label {
                    cursor: pointer;
                    color: #606266;
                  }
                  /deep/ .el-radio__label {
                    .radio_item {
                      display: inline-flex;
                      flex-flow: column;
                      width: 100%;
											white-space: pre-wrap;
											word-wrap: break-word;
											line-height: 20px;
                    }
                    p {
                      display: inline-block;
                      white-space: pre-wrap;
                      word-wrap: break-word;
                      box-sizing: border-box;
                      width: 96%;
                      img {
                        width: 100%;
                      }
                    }
                  }
                  /deep/ .el-checkbox__label {
                    p {
                      display: inline-flex;
											white-space: pre-wrap;
											word-wrap: break-word;
											box-sizing: border-box;
											width: 96%;

                    }
                  }
                  /deep/ .el-radio__input.is-disabled {
                    .el-radio__inner {
                      background-color: #fff;
                    }
                  }
                  /deep/ .el-checkbox__input.is-disabled {
                    .el-checkbox__inner {
                      background-color: #fff;
                    }
                  }
                  /deep/ .el-checkbox__input.is-disabled+span.el-checkbox__label {
                    cursor: pointer;
                    color: #606266;
                  }
                  .el-radio {
                    width: 100%;
                  }
                }
              }
              p {
                font-size: 14px;
                margin-bottom: 12px;
                span {
                  color: #5397F7;
                }
              }
              .analysis {
                color: #5397F7;
                font-size: 14px;
                cursor: pointer;
                float: left;
                img {
                  display: inline-block;
                  width: 10px;
                  height: 10px;
                  margin-left: 4px;
                }
              }
              .analysis_cont {
                float: left;
                width: calc(100% - 105px);
                color: #333333;
                font-size: 14px;
                line-height: 24px;
                margin-bottom: 32px;
                margin-left: 24px;
                margin-top: -4px;
              }
              .answerShow,.intoSystem,.answerHide {
                color: #5397F7;
                font-size: 14px;
                cursor: pointer;
                img {
                  display: inline-block;
                  width: 10px;
                  height: 10px;
                  margin-left: 4px;
                }
              }
              .intoSystem {
                margin-left: 40px;
              }
              .commentCont {
                position: relative;
                .comment1 {
                  width: 0px;
                  height:0px;
                  border: 8px transparent solid;
                  border-bottom-color: #F4F4F4;
                  position: absolute;
                  top: -15px;
                  left: 41px;
                }
                .comment2 {
                  background: #F4F4F4;
                  /*min-height: 105px;*/
                  /*max-height: 396px;*/
                  height: 396px;
                  border-radius: 4px;
                  margin-top: 10px;
                  padding: 16px;
                  overflow: auto;
                }
                .comment3 {
                  width: 0px;
                  height:0px;
                  border: 9px transparent solid;
                  border-bottom-color: rgba(244,244,244,1);
                  position: absolute;
                  top: -15px;
                  left: 40px;
                }
              }
              .combination {
                padding-top: 15px;
                padding-bottom: 25px;
                .groupQuestion {
                  clear: both;
                  margin-bottom: 10px;
                  .question_content {
                    max-width: 100%;
                    span {
                      float: left;
                      margin-right: 10px;
                      line-height: 21px;
                      font-weight: 600;
                    }
                    p.text {
                      /deep/ p {
                        line-height: 24px;
                        width: 97%;
                        word-break: break-word;
                        img {
                          display: block;
                          max-width: 100%;
                        }
                      }
                    }
                  }
                }
                .test_small_title {
                  /deep/ p {
                    line-height: 24px;
                  }
                }
                .analysis {
                  margin-bottom: 15px;
                }
                .question_index {
                  display: block;
                  font-weight: 600;
                  font-size: 14px;
                }
              }
              .line {
                height:0px;
                border:1px solid rgba(83,151,247,1);
              }
            }
          }
        }
      }
    }
  }
  .answer_box{
    display: flex;
    justify-content: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testing/preview.vue